const STATUS_CODES_BLOCK_INPUTS = [1, 2, 4]

export default STATUS_CODES_BLOCK_INPUTS 